<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div :class="!clientTasks ? 'mt-3' : ''" style="position: relative;">
        <template>
            <template v-if="tasks.length || Object.keys(groupedEvents).length">
                <template v-if="$vuetify.breakpoint.smAndDown && Object.keys(groupedEvents).length">
                    <CalendarEvents
                        v-if="selectedDateRange[0] && groupedEvents[selectedDateRange[0]]"
                        :events="groupedEvents[selectedDateRange[0]]"
                    />
                </template>
                <div>
                    <template v-for="([group, items], index) in Array.from(groupedTasks)">
                        <div :key="group">
                            <div v-if="alwayOpenGrouping || String(group).startsWith('ungrouped')">
                                <div
                                    v-if="!String(group).startsWith('ungrouped')"
                                    class="px-3 pb-5 pt-7 title ml-12"
                                    :class="!isMobile ? 'pl-0' : ''"
                                    :style="index === 0 && !isMobile ? 'padding-top: 0px !important;' : ''"
                                >
                                    {{ formatOpenGroupHeader(group) }}
                                </div>
                                <div
                                    test-id="tasks-list"
                                    class="global-elevation rounded-lg white"
                                >
                                    <slot
                                        v-for="(item, i) in items"
                                        name="row"
                                        :item="item"
                                        :index="i"
                                        :chip-columns="chipColumns"
                                        :show-client-name="showClientName"
                                        :is-mobile="isMobile"
                                        :is-first="i === 0"
                                        :is-last="i === items.length - 1"
                                    />
                                </div>
                            </div>
                            <div
                                v-else
                                :class="isMobile ? 'px-3' : ''"
                                class="global-elevation"
                                test-id="tasks-list"
                            >
                                <ExpandingSegment
                                    v-model="open_group_state"
                                    :open-key="group"
                                    :is-mobile="$vuetify.breakpoint.smAndDown"
                                    spaced-when-open
                                    dense
                                    table-mode
                                >
                                    <template slot="open-header">
                                        <v-row
                                            align="center"
                                            align-content="center"
                                            no-gutters
                                        >
                                            <span class="title">
                                                {{ groupedTasksHeaderInfo[group].group_title }}
                                            </span>
                                        </v-row>
                                    </template>
                                    <template slot="closed-actions">
                                        <span
                                            class="body-2 font-weight-medium"
                                            :class="[
                                                groupedTasksHeaderInfo[group].earliest_due_task.calc_status === 'overdue'
                                                    ? 'error--text'
                                                    : '',
                                                isMobile ? 'mr-1' : 'mr-3'
                                            ]"
                                        >
                                            {{ groupedTasksHeaderInfo[group].due_date }}
                                        </span>
                                    </template>
                                    <template slot="open-actions">
                                        <icon-button icon="X" />
                                    </template>
                                    <template slot="closed-header">
                                        <v-row
                                            v-if="isMobile"
                                            no-gutters
                                            align="center"
                                            align-content="center"
                                            style="flex-wrap: nowrap"
                                            class="fill-height"
                                        >
                                            <v-col class="shrink">
                                                <AccountAvatar
                                                    :color="groupedTasksHeaderInfo[group].color"
                                                    :initials="groupedTasksHeaderInfo[group].initials"
                                                    size="31"
                                                    tile
                                                    multiple
                                                    class="mr-3"
                                                />
                                            </v-col>
                                            <v-col
                                                style="line-height: 19px;"
                                                class="mt-1"
                                            >
                                                <span
                                                    class="font-weight-medium body-2"
                                                    style="white-space: nowrap"
                                                >
                                                    {{ items.length }} {{ $tc("task | tasks", items.length) }} </span><br />
                                                <span class="caption font-weight-medium grey--text">
                                                    {{ groupedTasksHeaderInfo[group].name }}
                                                </span>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            v-else
                                            no-gutters
                                            align="center"
                                            align-content="center"
                                            style="flex-wrap: nowrap"
                                            class="fill-height"
                                        >
                                            <AccountAvatar
                                                :color="groupedTasksHeaderInfo[group].color"
                                                :initials="groupedTasksHeaderInfo[group].initials"
                                                size="31"
                                                tile
                                                multiple
                                                class="mr-3"
                                            />
                                            <div style="flex-wrap: unset; white-space: normal; display: inherit;">
                                                <span
                                                    class="body-2 font-weight-medium pr-2 text-truncate"
                                                    style="min-width: 150px; width: 150px !important; max-width: 150px; "
                                                >
                                                    {{ groupedTasksHeaderInfo[group].name }}
                                                </span>
                                                <template v-for="(chip, chip_index) in chipColumns">
                                                    <v-chip
                                                        v-if="
                                                            groupedTasksHeaderInfo[group].topic &&
                                                                chip &&
                                                                chip.value &&
                                                                chip.value === 'topic'
                                                        "
                                                        :key="'chip' + chip_index"
                                                        class="mr-2 grey lighten-3"
                                                        small
                                                    >
                                                        <span class="font-weight-medium neutral_n90--text">
                                                            {{ groupedTasksHeaderInfo[group].topic }}
                                                        </span>
                                                    </v-chip>
                                                </template>
                                                <span
                                                    class="ml-5 font-weight-medium body-2"
                                                    style="white-space: nowrap"
                                                >
                                                    {{ items.length }} {{ $tc("task | tasks", items.length) }}
                                                </span>
                                                <span
                                                    v-if="groupedTasksHeaderInfo[group].overdue"
                                                    class="isoverdue mx-3 body-2"
                                                    style="white-space: nowrap"
                                                >
                                                    {{ groupedTasksHeaderInfo[group].overdue }}
                                                </span>
                                            </div>
                                        </v-row>
                                    </template>
                                    <div class="v-data-table dashboard-table theme--light">
                                        <div
                                            :class="clientTasks ? 'global-elevation' : 'my-3 global-elevation'"
                                            class="rounded-lg"
                                        >
                                            <slot
                                                v-for="(item, i) in items"
                                                name="row"
                                                :item="item"
                                                :index="i"
                                                :chipColumns="chipColumns"
                                                :showClientName="showClientName"
                                                :isMobile="isMobile"
                                                :is-first="i === 0"
                                                :is-last="i === items.length - 1"
                                            >

                                            </slot>
                                        </div>
                                    </div>
                                </ExpandingSegment>
                            </div>
                        </div>
                    </template>
                </div>
                <slot name="bottom"></slot>
            </template>
        </template>
    </div>
</template>

<script>
import CalendarEventModule from "../../store/modules/calendar_event";
import { deepClone } from "@/helpers/helpers";
import { reactive, toRefs, ref, computed } from "@vue/composition-api";
import { $t } from "@/i18n";
import {useTopicStore} from "../../store/modules/topic";
import ClientModule from "../../store/modules/client";
import AppModule from "../../store/modules/app";
import ExpandingSegment from "../../components/ExpandingSegment";
import { customGroupFunction } from "../../helpers/helpers";
import AccountAvatar from "../../components/AccountAvatar";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import {
    formatDateShort,
    formatOverdue,
    calcDateEquals,
    parseSysDate,
    formatDateCustom,
    calcDateDiff,
    CustomFormats
} from '../../plugins/formatting'
import CalendarEvents from "@/views/Calendar/CalendarEvents.vue";

export default {
    name: "TasksList",
    components: {
        ExpandingSegment,
        AccountAvatar,
        CalendarEvents
    },
    props: {
        groupBy: {
            type: String,
            default: "",
        },
        tasks: {
            type: Array,
            required: true
        },
        chipColumns: {
            type: Array,
            required: true
        },
        showClientName: {
            type: Boolean
        },
        alwayOpenGrouping: {
            type: Boolean
        },
        selectedDateRange: {
            type: Array,
            default: () => []
        },
        isMobile: {
            type: Boolean
        },
        clientTasks: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const { clients } = ClientModule();
        const loading = ref(false);
        const { events } = CalendarEventModule();
        const topicStore = useTopicStore()

        const groupedEvents = computed(() => {
            return customGroupFunction(events.value, task => getDateGroupKey(task), 1, false, "date_from");
        });

        //DATA
        const state = reactive({
            open_group_state: undefined,
            group_header_info: {},
            pagination: {
                sortBy: null,
                descending: null
            },
            current_months_tasks_label: $t("Current month's tasks"),
            in_progress_label: $t("In progress"),
            extra_work_tooltip: $t("extra work"),
            is_important_tooltip: $t("important"),

            headers: [
                { text: "Client", value: "client", align: "left", width: "20px" },
                { text: "Task", value: "taskname", align: "left", width: "200px" },
                { text: "Person", value: "persont", align: "left", width: "2%" },
                { text: "f", value: "f", align: "left", width: "50px" },
                { text: "dates", value: "dates", align: "right" },
                { text: "readydate", value: "ready", align: "right" }
            ],
            tableheaders: true,
            tableactions: true,
            row_items: [20],
            items: [],
            notes_label: $t("Notes"),
            placeholder_text: "",
            namespace: "client_profile",
            events_context: "client_current_month_events"
        });

        //METHODS
        const getClientGroupKey = task => {
            let account_id = task && task.account_id ? task.account_id : "0";
            let client_id = task && task.client_id ? task.client_id : "0";
            return `${account_id}_${client_id}`;
        };
        const getSimilarGroupKey = task => {
            const due_date_str = task
                ? task.due_date
                    .substr(0, 16)
                    .replace(" ", "_")
                    .replace(":", "")
                : "0";
            const id_str = task && task.topic_id ? "to" + task.topic_id : "ta" + task.virtual_id;
            return `${due_date_str}_${id_str}`;
        };
        const getWeek = d => {
            const date = new Date(d);
            date.setHours(0, 0, 0, 0);
            date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
            const week1 = new Date(date.getFullYear(), 0, 4);
            return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
        };
        const getDateGroupKey = task => {
            let date_from = parseSysDate(props.selectedDateRange[0]);
            let date_until = parseSysDate(props.selectedDateRange[1]);
            let diff_month = calcDateDiff.inMonths(date_from, date_until);
            let diff_day = calcDateDiff.inDays(date_from, date_until);
            if (diff_day < 7) {
                return task ? task.date.substr(0, 10) : "0";
            } else if (diff_month < 1) {
                if (task) {
                    const week = getWeek(task.date);
                    return "W" + task.date.substr(0, 4) + "_" + week;
                }
                return "0";
            }
            return task ? task.date.substr(0, 7) : "0";
        };
        const getTopicGroupKey = task => {
            return task && task.topic_id ? task.topic_id : "0";
        };
        const getUniqueTaskClients = tasks => {
            const result = [];
            const map = new Map();
            for (const task of tasks) {
                if (!map.has(task.client_id)) {
                    map.set(task.client_id, true); // set any value to Map
                    result.push(task.client);
                }
            }
            return result;
        };

        const getTopicNameById = (topicId) => {
            if (topicId === "0") {
                return $t("Without topic");
            }
            const topic = topicStore.getTopicById(topicId)
            if (topic) {
                return topic.name;
            }
            return "";
        }

        const groupedTasks = computed(() => {
            // console.info('groupedTasks :: props.groupBy', props.groupBy)
            let output = new Map();
            let items_clone = [...props.tasks];
            if (!props.groupBy) {
                output.set('ungrouped', items_clone)
                return output
            }

            items_clone.sort((a, b) => {
                const dueDayA = a.due_date.split(" ")[0];
                const dueDayB = b.due_date.split(" ")[0];
                const dayA = a.date.split(" ")[0];
                const dayB = b.date.split(" ")[0];

                if (dueDayA > dueDayB) return 1;
                if (dueDayA < dueDayB) return -1;

                if (dayA > dayB) return 1;
                if (dayA < dayB) return -1;

                return 0;
            });
            // console.log('000 groupedTasks props.groupBy =>', props.groupBy)
            // props.groupBy is a String (fallback support for Array)
            if (props.groupBy && props.groupBy.includes("client")) {
                output = customGroupFunction(items_clone, task => getClientGroupKey(task), 1, false, 'client.name', true);
            } else if (props.groupBy && props.groupBy.includes("similar")) {
                output = customGroupFunction(items_clone, task => getSimilarGroupKey(task), 4);
            } else if (props.groupBy && props.groupBy.includes("date")) {
                // console.log('111 getDateGroupKey', items_clone)
                output = customGroupFunction(items_clone, task => getDateGroupKey(task), 1, true);
            } else if (props.groupBy && props.groupBy.includes("topic")) {
                output = customGroupFunction(items_clone, task => getTopicGroupKey(task), 1, false, 'topic.name', true);
            } else {
                output.set('ungrouped', items_clone)
            }

            return output;
        });

        const groupedTasksHeaderInfo = computed(() => {
            const group_info_map = {};
            groupedTasks.value.forEach((grouped_tasks, group_key) => {
                if (!grouped_tasks.length) return;
                const earliest_due_task = grouped_tasks.reduce((a, b) => (a.due_date < b.due_date ? a : b));
                const task_has_client = grouped_tasks[0] && grouped_tasks[0].client;
                if (props.groupBy && props.groupBy.includes("client") && !String(group_key).startsWith("ungrouped")) {
                    group_info_map[group_key] = {
                        group_title: task_has_client ? grouped_tasks[0].client.name : "unknown",
                        initials: task_has_client ? grouped_tasks[0].client.client_initials : "BUG",
                        color: task_has_client ? grouped_tasks[0].client.color : "red accent-4",
                        name: task_has_client ? grouped_tasks[0].client.name : "unknown",
                        tasks_count: String(grouped_tasks.length),
                        topic: "",
                        earliest_due_task: earliest_due_task,
                        overdue:
                            earliest_due_task.calc_status === "overdue" ? formatOverdue(earliest_due_task.overdue_seconds) : "",
                        due_date: formatDateShort(earliest_due_task.due_date)
                    };
                } else if (props.groupBy && props.groupBy.includes("similar") && !String(group_key).startsWith("ungrouped")) {
                    const unique_clients = getUniqueTaskClients(grouped_tasks);
                    const client_name_parts = [unique_clients[0].name];
                    if (unique_clients.length > 1) client_name_parts.push("+" + unique_clients.length - 1);
                    const topic = topicStore.getTopicById(grouped_tasks[0].topic_id);
                    group_info_map[group_key] = {
                        group_title: topic ? topic.name : "",
                        initials: String(grouped_tasks.length),
                        color: "grey darken-2",
                        name: client_name_parts.join(" "),
                        tasks_count: "",
                        topic: topic ? topic.name : "",
                        earliest_due_task: earliest_due_task,
                        overdue:
                            earliest_due_task.calc_status === "overdue" ? formatOverdue(earliest_due_task.overdue_seconds) : "",
                        due_date: formatDateShort(earliest_due_task.due_date)
                    };
                }
            });
            return group_info_map;
        });
        const formatOpenGroupHeader = val => {
            if (props.groupBy && props.groupBy.includes("client")) {
                const client = clients.value.find(client => client.id === Number(val.split("_")[1]));
                if (client) {
                    return client.name;
                }
                return "";
            } else if (props.groupBy && props.groupBy.includes("similar")) {
                const topic = topicStore.topics.getTopicById(Number(val.split("_")[2].substring(2)));
                if (topic) {
                    return topic.name;
                }
                return "";
            } else if (props.groupBy && props.groupBy.includes("date")) {
                if (val.startsWith("W")) {
                    const parts = val.substring(1).split("_");
                    const week = parts[1];
                    // const year = parts[0];
                    if (Number(week) === Number(getWeek(new Date()))) {
                        return $t("This week") + " (" + week + ")";
                    } else if (Number(week) === Number(getWeek(new Date())) + 1) {
                        return $t("Next week") + " (" + week + ")";
                    } else if (Number(week) === Number(getWeek(new Date())) - 1) {
                        return $t("Last week") + " (" + week + ")";
                    } else {
                        return $t("Week") + " " + week;
                    }
                } else if (val.length === 10) {
                    let now = new Date();
                    if (calcDateEquals(parseSysDate(val), now, "day")) {
                        return $t("Today");
                    } else if (calcDateEquals(parseSysDate(val), now.calcAddDays(1), "day")) {
                        return $t("Tomorrow");
                    } else if (calcDateEquals(parseSysDate(val), now.calcAddDays(-1), "day")) {
                        return $t("Yesterday");
                    } else {
                        return formatDateShort(parseSysDate(val));
                    }
                } else if (val.length === 7) {
                    let full_date = val + "-01";
                    let now = new Date();
                    if (calcDateEquals(parseSysDate(full_date), now, "month")) {
                        return $t("This month");
                    } else if (calcDateEquals(parseSysDate(full_date), now.calcAddMonths(1), "month")) {
                        return $t("Next month");
                    } else if (calcDateEquals(parseSysDate(full_date), now.calcAddMonths(-1), "month")) {
                        return $t("Previous month");
                    } else {
                        return formatDateCustom(parseSysDate(full_date), CustomFormats.month_name_with_full_year);
                    }
                }
                return val + "m";
            } else if (props.groupBy && props.groupBy.includes("topic")) {
                return getTopicNameById(val)
            } else {
                return val + "asd";
            }
        };

        return {
            ...toRefs(state),
            loading,
            groupedTasks,
            getUniqueTaskClients,
            groupedTasksHeaderInfo,
            formatOpenGroupHeader,
            groupedEvents
        };
    }
};
</script>

<style lang="scss" scoped>
.isoverdue {
    color: var(--v-error-base);
    font-weight: 500;
}
</style>
